'use strict';

import React from 'react';

function Separator(props) {
    return <div style={{ ...props.style }} className="separator">{props.text}</div>;
}

export default Separator;